import { Box } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/HrManagements/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../store/reducers/user";

const HrmsMainLayout = () => {
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state.users);

  const getData = useCallback(() => {
    if (users.length === 0) {
      dispatch(getUsers());
    }
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Box sx={{ marginTop: "3rem" }}>
      <Box
        component="main"
        sx={{
          p: "2rem 1rem",
          display: "flex",
          "@media(max-width: 600px)": {
            p: "2.5rem  0.8rem",
          },
        }}
      >
        <Sidebar />

        <Outlet />
      </Box>
    </Box>
  );
};

export default HrmsMainLayout;
